<template>
	<div>
		<div class="profile">
			<img class="profile-image" :src="require('@/assets/profile-admin.png')" />
			<div class="profile-name">
				{{ $api.user.name }}<br/>
				<span>B2B - Administração</span>
			</div>
		</div>

		<div class="menu-items">
			<router-link class="menu-item" to="/">
				<i class="fa fa-fw fa-home"></i> INÍCIO
			</router-link>

			<router-link class="menu-item" to="/admin/admin">
				<i class="fa fa-fw fa-user"></i> ADMINISTRADORES
			</router-link>

			<router-link class="menu-item" to="/admin/company">
				<i class="fa fa-fw fa-building"></i> EMPRESAS
			</router-link>
			
			<router-link v-if="false" class="menu-item" to="/admin/customer">
				<i class="fa fa-fw fa-user"></i> CLIENTES
			</router-link>

			<router-link class="menu-item" to="/admin/drivers">
				<i class="fa fa-fw fa-truck"></i> MOTORISTAS
			</router-link>

			<router-link class="menu-item" to="/admin/externalaccess">
				<i class="fa fa-fw fa-plug"></i> INTEGRAÇÕES
			</router-link>
			
			<router-link class="menu-item" to="/admin/log">
				<i class="fa fa-fw fa-file"></i> LOGS
			</router-link>

			<router-link class="menu-item" to="/admin/setting">
				<i class="fa fa-fw fa-cogs"></i> CONFIGURAÇÕES
			</router-link>

			<a class="menu-item" @click="logout">
				<i class="fa fa-fw fa-sign-out-alt"></i> SAIR
			</a>
		</div>

		<div v-if="!hide_popup" class="popup-alert" :class="{'show': show_popup}">
			<h4>ATENÇÃO</h4>
			Você está no modo de administrador
		</div>
	</div>
</template>

<script>
import Api from "@/lib/Api";

export default {
	name: "MenuAdmin",

	data: function() {
		return {
			show_popup: false,
			hide_popup: false,
		}
	},	

	mounted: function() {
		setTimeout(() => {
			this.show_popup = true;
		}, 50);
		setTimeout(() => {
			this.hide_popup = true;
		}, 5000);
	},

	methods: {
		logout: function() {
			Api.logout("admin");
		},
	},
}

</script>

<style scoped>
.header {
	float: left;
	width: 100%;
	padding: 15px 55px 0 55px;
}

.header-image {
	width: 100%;
}



.profile {
	float: left;
	width: 100%;
	padding: 15px;
	background: #595959;
}


.profile-image {
	float: left;
	width: 50px;
	height: 50px;
	border-radius: 100%;
	background: #fff;
}



.profile-name {
	position: relative;
    float: left;
    width: calc(100% - 60px);
    color: #fff;
    text-align: left;
    padding: 6px 15px;
}
.profile-name > span {
	color: #fff;
	font-size: 12px;
	font-weight: bold;
}





.menu-items {
	float: left;
	width: 100%;
	padding-top: 1px;
	margin-top: 0px;
}

.menu-item {
	position: relative;
	float: left;
	width: 100%;
	height: 50px;
	line-height: 52px;
	background: #d9d9d9;
	border: none;
	text-align: left;
	padding: 0 15px 0 50px;
	color: #000;
	font-weight: bold;
	font-size: 16px;
	margin-bottom: 1px;
	text-decoration: none;
}

.menu-item > i {
	position: absolute;
	top: 16px;
	left: 15px;
	font-size: 18px;
}

.router-link-exact-active {
	background: #a6a6a6;
}




.popup-alert {
	width: 300px;
	height: 60px;
	position: fixed;
	top: -30px;
	left: 0;
	right: 0;
	background: #fff;
	margin: auto;
	z-index: 9;
	padding: 10px;
	text-align: center;
	opacity: 0;
	transition: all 0.5s ease-in;
	border: 1px solid #ccc;
	border-radius: 4px;
	-webkit-box-shadow: 5px 5px 5px -5px rgba(0,0,0,0.75);
	-moz-box-shadow: 5px 5px 5px -5px rgba(0,0,0,0.75);
	box-shadow: 5px 5px 5px -5px rgba(0,0,0,0.75);
	font-size: 14px;
	font-weight: bold;
	cursor: default;
}
.popup-alert.show {
	opacity: 1;
	top: 30px;
}
.popup-alert > h4 {
	margin: 0;
	padding: 0;
	font-size: 18px;
}
</style>